import script from "./AiIntentRuleEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./AiIntentRuleEditor.vue?vue&type=script&setup=true&lang=js"

import "./AiIntentRuleEditor.vue?vue&type=style&index=0&id=8109daf0&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/91znxra3/0/cs/cs-manager-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8109daf0"]])

export default __exports__